'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentFormDialogController = function () {
  function PaymentFormDialogController(fFeisService, fPaymentsService, fStripe, $state, $mdDialog, balance, account, feis, showCartLink, ccFee, toBeChargedAccounts, msgService) {
    _classCallCheck(this, PaymentFormDialogController);

    this._ = { fFeisService: fFeisService, fStripe: fStripe, $state: $state, $mdDialog: $mdDialog, msgService: msgService };
    this.balance = balance;
    this.loading = 0;
    this.feis = feis;
    this.toBeChargedAccounts = toBeChargedAccounts;
    this.ccFee = ccFee;
    this.showCartLink = showCartLink === undefined ? true : showCartLink;
    this._payments = fPaymentsService.forAccount(account.id).forFeis(feis.id);
  }

  _createClass(PaymentFormDialogController, [{
    key: 'goTo',
    value: function goTo(state) {
      this.close();
      this._.$state.go(state, this.feis);
    }
  }, {
    key: 'close',
    value: function close() {
      this._.$mdDialog.cancel();
    }
  }, {
    key: 'pay',
    value: function pay(amount, card) {
      var _this = this;

      this.loading++;

      this._.fStripe.token(card.number, card.exp_year, card.exp_month, card.cvc).then(function (token) {
        return _this._payments.credit(amount, token, null, _this.feis.currency, _this.toBeChargedAccounts);
      }).then(function () {
        _this._.msgService.displaySuccessMsg('Your payment has been successfully processed. Thank you!');
        _this._.$mdDialog.hide();
      }).catch(function (e) {
        var err = e;
        if (typeof err !== 'string') {
          if (e.message) {
            err = e.message;
          } else {
            err = e.data ? e.data.errors : undefined;
            err = err && err[0] ? err[0].detail : 'Unknown Error';
          }
        }
        _this._.msgService.displayErrorMsg(err);
      }).finally(function () {
        return _this.loading--;
      });
    }
  }]);

  return PaymentFormDialogController;
}();

exports.default = angular.module('ifeis.payment-form', ['ngMaterial']).factory('fPaymentFormDialog', function ($mdDialog, $mdMedia) {
  return function (ev, balance, account, feis, showCartLink) {
    var ccFee = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var toBeChargedAccounts = arguments[6];

    return $mdDialog.show({
      controller: 'PaymentFormDialogController',
      controllerAs: 'ctrl',
      template: require('./tpl.html'),
      targetEvent: ev,
      clickOutsideToClose: false,
      fullscreen: $mdMedia('xs'),
      locals: {
        balance: balance,
        account: account,
        feis: feis,
        showCartLink: showCartLink,
        ccFee: ccFee,
        toBeChargedAccounts: toBeChargedAccounts
      }
    });
  };
}).controller('PaymentFormDialogController', PaymentFormDialogController);


//////////////////
// WEBPACK FOOTER
// ./payment-form/index.js
// module id = 102
// module chunks = 0